/* import __COLOCATED_TEMPLATE__ from './card.hbs'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { group } from '@banking/ui/utils/activity';
const MAX_LENGTH = 6;
let Card = (_class = class Card extends Component {
  get groupedActivities() {
    return group(this.args.activities);
  }
  get hasActivities() {
    return this.args.activities.length > 0;
  }
  get limitedActivities() {
    const activities = this.groupedActivities.pending.slice(0, MAX_LENGTH);
    return [...activities, ...this.groupedActivities.completed.slice(0, MAX_LENGTH - activities.length)];
  }
  goToActivity(activity, event) {
    // Deselect the row that was just selected
    event.target.deselect();
    this.args.goToActivity(activity);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "goToActivity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToActivity"), _class.prototype)), _class);
export { Card as default };